export const getFormFiltro = () => ({
    txtFechaDe: {
        label: "Fecha de inicio:",
        value: null,
    },
    txtFechaA: {
        label: "Fecha de fin:",
        value: null,
    },
    txtEstatus: {
        label: "Estatus de pago:",
        value: "",
    },
    txtOrigen: {
        label: "Origen:",
        value: "",
    },
    txtTipoPago: {
        label: "Tipo de pago:",
        value: "",
    },
    txtOrden: {
        label: "Orden Conekta:",
        value: "",
    },
    txtFolio: {
        label: "Folio de paciente:",
        value: "",
    },
    txtFolioEmpresa: {
        label: "Folio de empresa:",
        value: "",
    },
    txtCupon: {
        label: "Cupón de descuento:",
        value: null,
    },
});

export const getModelOrden = () => ({
    sOrderId: "",
    nAmount: 0,
    nAmountDiscount: 0,
    nAmountTax: 0,
    nAmountPaid: 0,
    customer_info: {},
    charges: {},
    lstProductos: [],
});

export const getAdministrativoColumns = () => [
    { title: "Orden", field: "sOrderId" },
    { title: "Folio de empresa", field: "sFolioEmpresa" },
    { title: "Total", field: "nAmountPaid" },
    { title: "Nombre", field: "sNombre" },
    { title: "Fecha", field: "sRegisterDate" },
    { title: "Detalle", field: "sDetalle", hideSort: true, hideFilter: true },
];

export const getConektaColumns = () => [
    { title: "Orden", field: "sOrderId" },
    { title: "Origen", field: "sOrigen" },
    { title: "Total", field: "nAmountPaid" },
    { title: "Cupón", field: "sCodigo" },
    { title: "Estatus", field: "sPaymentStatusWI" },
    { title: "Fecha", field: "sRegisterDate" },
    { title: "Detalle", field: "sDetalle", hideSort: true, hideFilter: true },
];
